import React, { useState,useEffect} from "react";
import {NavLink} from "react-router-dom";
import { useAappContext } from "../context/AppContext";
import loading from '../assest/loading/Settings.gif'
const Header = ()=>{

const {isLoaadingAvansis,Avansis:avansis,ApiHost}= useAappContext();

//searchCode
const [searchQuery, setSearchQuery] = useState('');
const handleSearch = (e)=>{
    e.preventDefault();
    if(!searchQuery.trim()) return;
    window.location.href = `/products?query=${encodeURIComponent(searchQuery)}`;
} 



// Slider code
const [isActive,setisActive] = useState(false)
const activeSidebar =()=>{
    setisActive(!isActive)
}
//fixing navbar
const [FixingNavbar, setFixingNavbar] = useState(false)
useEffect(() => {
   window.addEventListener('scroll',()=>{
    var scroll_position = window.scrollY;
    if(scroll_position > 248){
     setFixingNavbar(!FixingNavbar)
    }else{
      setFixingNavbar(false)  
    }
     })
},[])
    if(isLoaadingAvansis){
    return (
        <>
        <div style={{
        minHeight:400,
        display:'flex',
        justifyContent:"center",
        alignItems:"center",
        fontSize:18,
        color:"green"
      }}>..........Loading</div>
        </>
    )
    }
    return (
        <>
    <section id="brand" className="section-m1" style={{paddingTop:25}}>
        
        { avansis.length >0 ? (
             avansis.map((data)=>{
                const {id:cmid,logo,name, mobaile}=data;
                return(<div key={cmid}
                style={{
                    width:'100%',
                    flexWrap:"wrap",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    padding:0,
                    margin:0,
                    
                }}
                >
                    <link rel="icon" href={ApiHost+logo} />
                    <div className="brand-logo">
                    <div className="image">
                    <img src={ApiHost+logo}  height="100" alt="" />
                    </div>
                    <div className="title cname">
                    <span className="cname">{name}</span>
                    </div> 
                    </div>
                    <div className="brand-contact">
                    <span>{mobaile}</span>
                    </div>
                </div>)
            })
        ):(<div style={{
            minHeight:'100vh',
            display:'flex',
            justifyContent:"center",
            alignItems:"center",
            fontSize:18,
            color:"green",
            marginLeft:'50%',
          }}> <img src={loading} alt="" /> </div>)
           
        } 
       
       
    </section>


    <section id="top-ribbon" className={FixingNavbar ? 'fix-navbar section-m1': 'section-m1'}>
        <div>
            <ul id="navbar" className={`${isActive ? 'nav-mVew':''}`}>
                <li><NavLink to="/" onClick={activeSidebar}>
                HOME
                </NavLink></li>
                <li><NavLink to="/products" onClick={activeSidebar}>
                PRODUCT
                </NavLink></li>
                <li><NavLink to="/news" onClick={activeSidebar}>
                NEWS
                </NavLink></li>
                <li><NavLink to="/recruitsment" onClick={activeSidebar}>
                RECRUITMENT
                </NavLink></li>
                <li><NavLink to="/aboutus" onClick={activeSidebar}> 
                ABOUT US
                </NavLink></li>
                <li><NavLink to="/contactus" onClick={activeSidebar}>
                CONTACT US
                </NavLink></li>
            </ul>
            
        </div>
        {/* <NavLink to={false}>
                   <AddShoppingCartIcon style={{fontSize:28,color:"white"}}></AddShoppingCartIcon>
        </NavLink> */}
        <div className="search-continer">
                <form onSubmit={handleSearch} method="post">
                    <input type="search" style={{padding:'0 8px'}}
                    name="search" className="ser-1"
                    id="search-tex"
                    placeholder="Search"
                    value={searchQuery}
                    onChange = {(e)=>setSearchQuery(e.target.value)}
                    />
                <button type="submit">
                    <i className="fa-solid fa-magnifying-glass fa-beat"></i>
                </button> 
            </form>
                     
            </div>
            <div className={`hamburgar ${isActive ? 'active':''}`} onClick={activeSidebar} >
                <div className="bar">
                    
                </div>
             </div> 
    </section>



        </>
    );

}

export default Header;